import { render, staticRenderFns } from "./VisorTransacciones.vue?vue&type=template&id=6474257b&scoped=true"
import script from "./VisorTransacciones.vue?vue&type=script&lang=js"
export * from "./VisorTransacciones.vue?vue&type=script&lang=js"
import style0 from "./VisorTransacciones.vue?vue&type=style&index=0&id=6474257b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6474257b",
  null
  
)

export default component.exports